import { useMemo } from "react";
import { object, string } from "yup";
import { phoneOptionalValidation } from "common-frontend-components";
const useContactValidationSchema = (phoneContainer) => useMemo(() => {
    return object().shape({
        firstName: string().min(1).max(100),
        lastName: string().min(1).max(100),
        // @ts-ignore
        phone: phoneOptionalValidation(phoneContainer),
        email: string().email().required(),
        message: string().min(0).max(500),
    });
}, [phoneContainer]);
export { useContactValidationSchema, };
//# sourceMappingURL=contactValidation.js.map